import { RTU } from '../../../types/RTU';

export const getRtuMembershipSignature = (rtus: ReadonlyArray<Pick<RTU, 'id'>> | null | undefined): string =>
  (rtus ?? [])
    .map((rtu) => String(rtu.id))
    .sort()
    .join('|');
